import * as React from "react";
import { Input, Button, Row, Col, Form } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { documentsQueryStore } from "../../Stores/DocumentsQueryStore";
import { I18N_NS } from "Config/i18n";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";
import { DocumentsSearchForm } from "./DocumentsSearchForm";
import { documentsSearchStore } from "../../Stores/DocumentsSearchStore";
import { Spin } from "Components/General/Spin";
import { Loader } from "Components/General/Loader";
import { documentsTableStore } from "../../Stores/DocumentsTableStore";

export interface SaveQueryFormProps extends WithTranslation, ModalComponentProps {
  initialData?: API_SearchQuery;
  isEdit?: boolean;
}

export const SaveQueryForm = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<SaveQueryFormProps> {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      private searchFormRef: React.RefObject<any> = React.createRef();

      componentDidMount() {
        if (this.props.isEdit) {
          if (this.props.initialData.id) {
            (async () => {
              await documentsQueryStore.setQueryToEdit(this.props.initialData.id);
            })();
          } else {
            console.warn("Query id is lost =(");
          }
        }
      }

      componentWillUnmount() {
        documentsSearchStore.setSearchReqQuery({});
      }

      handleSubmit = async (values) => {
        const { t, initialData } = this.props;
        const storedFormData = documentsSearchStore.getPostObject();
        const changedFormData = { ...storedFormData, ...this.searchFormRef.current.changedFormData, name: values.name };
        changedFormData.folderId = null;
        changedFormData.includeSubDirectories = null;
        switch (documentsSearchStore.radioValue) {
          case "CURR_DIR":
            changedFormData.folderId = documentsTableStore.currentFolderId;
            changedFormData.includeSubDirectories = false;
            break;
          case "CURR_CHILDREN":
            changedFormData.includeSubDirectories = true;
            changedFormData.folderId = documentsTableStore.currentFolderId;
            break;
        }

        try {
          // tslint:disable-next-line: max-line-length
          if (initialData) {
            await documentsQueryStore.editQuery(changedFormData, initialData.id);
          } else {
            await documentsQueryStore.saveQuery(changedFormData);
          }
          this.props.hideModal();
          notificationSuccess(t("Success"), t("Search query was saved"));
        } catch (error) {
          throw error;
        }
      };

      get formData() {
        const { initialData, isEdit } = this.props;
        if (isEdit) {
          return documentsSearchStore.getPostObject();
        } else {
          if (initialData) {
            return initialData;
          } else {
            return documentsSearchStore.getPostObject();
          }
        }
      }

      render() {
        const { t, initialData, isEdit } = this.props;
        if (isEdit && Object.keys(documentsSearchStore.searchReqQueries).length === 0) {
          return <Loader />;
        }
        return (
          <div>
            <Form layout="vertical" onFinish={this.handleSubmit} initialValues={initialData}>
              <Form.Item label={t("Query name")}>
                <Row gutter={8}>
                  <Col style={{ flexGrow: 1 }}>
                    <Form.Item
                      noStyle={true}
                      name="name"
                      rules={[{ required: true, message: t("This field is required") }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Button type="primary" htmlType="submit" loading={documentsQueryStore.state === "LOADING"}>
                      {t("Save query")}
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
            <Spin spinning={documentsQueryStore.fetchQueryState === "LOADING"}>
              <DocumentsSearchForm ref={this.searchFormRef} initialData={this.formData} hideSubmitButton={true} />
            </Spin>
          </div>
        );
      }
    }
  )
);
